import { render, staticRenderFns } from "./CustomerCorporateDelete.vue?vue&type=template&id=7bccdcec&scoped=true"
import script from "./CustomerCorporateDelete.vue?vue&type=script&lang=js"
export * from "./CustomerCorporateDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bccdcec",
  null
  
)

export default component.exports